(async () => {
    if (!customElements.get("video-slider")) {
        class VideoSlider extends HTMLElement {
            constructor() {
                super();
                this.swiperElement = this.querySelector("[data-video-slider-swiper]");
                this.playPauseButton = this.querySelector("[data-play-pause-button]");
                this.isAutoplaying = true;
                this.swiperOptions = {
                    loop: true,
                    autoplay: {
                        delay: 6000,
                        disableOnInteraction: false
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true
                    },
                    slidesPerView: 1.6,
                    centeredSlides: true,
                    observer: false,
                    threshold: 10,
                    breakpoints: {
                        320: {
                            slidesPerView: 1.3,
                            spaceBetween: 15
                        },
                        768: {
                            slidesPerView: 1.2,
                            spaceBetween: 20
                        },
                        1024: {
                            slidesPerView: 1.2,
                            spaceBetween: 20
                        },
                        1441: {
                            slidesPerView: 1.2,
                            spaceBetween: 20
                        },
                        1920: {
                            slidesPerView: 1.5,
                            spaceBetween: 20
                        },
                        2200: {
                            slidesPerView: 1.9,
                            spaceBetween: 20
                        }
                    }
                };
                this.init()
            }
            init() {
                this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
                if (this.playPauseButton) {
                    this.playPauseButton.addEventListener("click", (() => this.toggleAutoplay()))
                }
            }
            toggleAutoplay() {
                if (this.isAutoplaying) {
                    this.swiperInstance.autoplay.stop();
                    this.playPauseButton.classList.remove("pause");
                    this.playPauseButton.classList.add("play")
                } else {
                    this.swiperInstance.autoplay.start();
                    this.playPauseButton.classList.remove("play");
                    this.playPauseButton.classList.add("pause")
                }
                this.isAutoplaying = !this.isAutoplaying
            }
        }
        customElements.define("video-slider", VideoSlider)
    }
})();
//# sourceMappingURL=video-slider.js.map